/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { POSTCheckVersion } from "../../helpers/permisos/POSTCheckVersion";
import { useAuth } from "../../AuthContext";

// persiste entre montajes del componente, se reinicia con refresh
let _versionCheckExecuted = false;

export const useAppVersion = () => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  // Estados de las versiones (base de datos)
  const [backendVerfro, setBackendVerfro] = useState(null);
  const [backendVerbac, setBackendVerbac] = useState(null);
  const [usaModoLote, setUsaModoLote] = useState(null);

  const { loggedUser } = useAuth();

  const checkVersion = async () => {
    //  Bloquear si ya se ejecutó en esta carga de página
    if (showUpdateModal || isChecking || _versionCheckExecuted) return;

    setIsChecking(true);

    try {
      const currentVersion = process.env.REACT_APP_VERSION || null;
      const standarVersion = currentVersion?.replace("v", "").trim() || "N/A";

      const result = await POSTCheckVersion();

      if (result.success && result.data) {
        const backendVersion = result.data.verbac;
        const clientVersion = result.data.verfro;
        const modoLote = result.data.lotvto;

        setBackendVerbac(backendVersion || "N/A");
        setBackendVerfro(clientVersion || "N/A");
        setUsaModoLote(modoLote || false);

        //  Marcar como ejecutado apenas tenemos respuesta exitosa
        _versionCheckExecuted = true;

        // Control principal de actualización
        if (clientVersion && clientVersion !== standarVersion) {
          setShowUpdateModal(true);
        } else {
          // console.log(" Last version is being used, no update needed.");
        }
      }
    } catch (error) {
      console.warn("Error no capturado verificando versión del WMS", error);
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    const isUserLogged = loggedUser && Object.keys(loggedUser).length > 0;
    if (!isUserLogged) return;

    //  Ejecutar solo si no se chequeó antes en esta carga de página
    if (!_versionCheckExecuted) {
      const timer = setTimeout(() => {
        checkVersion();
      }, 500);

      const handleVisibilityChange = () => {
        if (!document.hidden && !_versionCheckExecuted) {
          checkVersion();
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        clearTimeout(timer);
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange,
        );
      };
    }
  }, [loggedUser]);

  const clearSession = () => {
    // Resetear el flag al cerrar sesión para permitir nuevo check en próximo login
    _versionCheckExecuted = false;

    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });

    localStorage.removeItem("userWMS");

    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("auditarSma_filtro_")) {
        localStorage.removeItem(key);
      }
    });
  };

  const handleUpdate = () => {
    clearSession();
    window.location.reload(true);
  };

  return {
    showUpdateModal,
    handleUpdate,
    backendVerbac,
    backendVerfro,
    usaModoLote,
  };
};
